(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !window.DesignMode) return;
  try {
    
var tabs = document.getElementById("tabs");
var sticky = tabs.offsetTop;
var topHeight=0;
  
   window.addEventListener('load', function() {
      init();
  });

  // 监听窗口大小变化，确保页面尺寸调整时动态更新
  window.addEventListener('resize', function() {
    init();
  });
  
window.onscroll = function() {
  init()
  stickyTabs();
};
  

function stickyTabs() {
    if (window.pageYOffset > sticky) {
        tabs.classList.add("sticky");
        tabs.style.top = topHeight + 'px';
    } else {
        tabs.classList.remove("sticky");
        tabs.style.top = 0;
    }
}

function init() {
  var stickyElements = document.querySelectorAll('.cc-header--sticky');
  if (stickyElements.length > 0) {
    const firstSticky = stickyElements[0];
    topHeight = firstSticky.offsetHeight;
    var menu = document.querySelectorAll('.main-menu');
    console.log("topHeight",topHeight,menu[0].offsetHeight)
    // if(menu.length>0){
    //   topHeight = topHeight - menu[0].offsetHeight;
    // }

    // 获取所有 Tab 链接
    const tab_links = document.querySelectorAll('.tab-link');
    
    // 遍历 Tab 链接，动态添加 scroll-margin-top
    tab_links.forEach(link => {
      const tab_link = link.getAttribute('href');
      if (tab_link && tab_link.startsWith('#')) {
        const target_id = tab_link.substring(1);
        const target_element = document.getElementById(target_id);
        if (target_element) {
          target_element.style.scrollMarginTop = tabs.offsetHeight + topHeight+'px';
        }
      }
    });
    
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });
  
  // 下拉菜单交互
document.querySelectorAll('[data-dropdown]').forEach(dropdown => {
  const toggle = dropdown.querySelector('[data-dropdown-toggle]');
  
  // 点击触发
  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('active');
  });

  // 点击外部关闭
  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('active');
    }
  });

  // 键盘交互
  toggle.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      dropdown.classList.toggle('active');
    }
  });
});

// 自动选中当前国家
const currentHost = window.location.hostname;
document.querySelectorAll('.dropdown-item').forEach(item => {
  const itemHost = new URL(item.href).hostname;
  if (itemHost === currentHost) {
    const flag = item.querySelector('.item-flag').cloneNode(true);
    document.querySelector('.dropdown-flag').replaceWith(flag);
    document.querySelector('.dropdown-label').textContent = item.querySelector('span').textContent;
  }
});

  } catch(e) { console.error(e); }
})();
})();
